import { alpha, styled } from '@mui/material';
import { ThemeColorKey } from '../../theme/types';

interface AnimationDotProps {
  size: number;
  topOffset: number;
  rightOffset: number;
  color: ThemeColorKey;
  className?: string;
}

export const AnimationDot: React.ComponentType<AnimationDotProps> = styled('div')<AnimationDotProps>(
  ({ size, topOffset, rightOffset, color, theme }) => ({
    ':after': {
      animation: `shadow-pulse__RutlBg 4s infinite`,
      backgroundColor: theme.vars.palette?.[color]?.main,
      borderRadius: '50%',
      content: '""',
      display: 'block',
      height: `${size}px`,
      width: `${size}px`,
      position: 'absolute',
      right: `${rightOffset}px`,
      top: `${topOffset}px`,

      '@keyframes  shadow-pulse__RutlBg': {
        '0%': { boxShadow: `0 0 0 0 ${alpha(theme.palette?.[color]?.main, 0.5)}` },
        '50%': { boxShadow: `0 0 0 0 ${theme.vars.palette?.[color]?.main}` },
        '100%': { boxShadow: `0 0 0 ${size}px transparent` },
      },
    },
  }),
);
